import "./assessment-select-modal.scss";

import classNames from "classnames";
import React, { useState } from "react";

import { Button, Flex, Icon, Typography } from "@/components/Elements";
import ModalWrapper from "@/components/shared/ModalWrapper";

import { AssessmentIndex } from "../../../types/assessment";

type AssessmentSelectModalProps = {
  templates: AssessmentIndex[];
  onCancel: () => void;
  onSubmit: (templateId: number, isPasswordProtected: boolean) => void;
};

const AssessmentSelectModal = (props: AssessmentSelectModalProps) => {
  // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  const [selectedId, setSelectedId] = useState<number>(null);
  const [isPasswordProtected, setIsPasswordProtected] = useState(false);
  return (
    <ModalWrapper width={500}>
      <div className="assessment-select">
        <Typography
          weight="semiBold"
          color="generalMidnightDark"
          size="md"
          label="Select a template:"
        />
        <div className="assessment-select__assessment-list">
          {props.templates?.map((template) => (
            <div
              key={template.id}
              className={classNames("assessment-select__assessment", {
                "assessment-select__assessment--selected":
                  selectedId === template.id,
              })}
              onClick={() => setSelectedId(template.id)}
            >
              <Typography
                label={template.name}
                color={
                  selectedId === template.id
                    ? "generalWhite"
                    : "generalMidnightDark"
                }
                weight="semiBold"
              />
            </div>
          ))}
        </div>
        <Flex alignCenter columnGap={5}>
          <input
            type="checkbox"
            checked={isPasswordProtected}
            onChange={(e) => setIsPasswordProtected(e.target.checked)}
          />
          <Typography
            color="generalMidnightDark"
            label="Add password protection"
            size="sm"
          />
          <Flex
            alignCenter
            data-tooltip-id="tooltip"
            data-tooltip-content="If selected, a password will be generated for each questionnaire attached to this assessment. You will need to share the password with the questionnaire form link as it will be required to fill out the form. This selection will not be editable after creation."
            data-tooltip-place="bottom"
          >
            <Icon name="info" />
          </Flex>
        </Flex>
        <div className="assessment-select__actions">
          <Button label="Cancel" theme="tertiary" onClick={props.onCancel} />
          <Button
            label="Create Assessment"
            theme="primary"
            onClick={() => props.onSubmit(selectedId, isPasswordProtected)}
            disabled={!selectedId}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AssessmentSelectModal;
